import { useEffect } from 'react';
import Menu from '../../../commons/Menu/Menu';

export default () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Menu />
      <div style={{ padding: 8 }}>
        <p style={{ whiteSpace: 'pre-line' }}>
          MENTIONS LÉGALES <br />
          Ce site est publié par Lens Group <br />
          Société par actions simplifiée (SAS) au capital de 1000 euros au 1er janvier 2023. <br />
          Immatriculée au RCS de Perpignan sous le numéro unique d'identification 847550910 <br />
          Numéro APE : 6201z <br />
          <br />
          Siège social : 2 Bis Avenue du Docteur Cartade <br />
          66310 ESTAGEL <br />
          Représentant légal : M. Herranz Kévin, Président <br />
          Contact: contact@lens-group.fr <br />
          La plateforme est hébergée par Lens Group. <br />
          RÉCLAMATIONS LÉGALES : <br />
          Vous pouvez adresser gratuitement vos réclamations à l’adresse email suivante :
          contact@lens-group.fr <br />
          Comment est traitée ma réclamation ? <br />
          Nous accuserons réception de votre réclamation dans un délai de 10 jours à compter de sa
          réception. <br />
          Afin de déterminer si votre réclamation est recevable, l’équipe en charge de la gestion
          des réclamations déterminera si les informations communiquées sont claires, et si toutes
          les pièces justificatives nécessaires ont bien été transmises. <br />
          Si tel n’est pas le cas, Publiconsult vous adressera dans les plus brefs délais et au plus
          tard 10 jours ouvrés à compter de la réception de la réclamation une notification
          expliquant clairement les raisons pour lesquelles la demande ne peut être acceptée, et
          vous invitant à la compléter ou à la reformuler. Tout retard dans le traitement des
          réclamations vous sera immédiatement indiqué par l’équipe en charge des réclamations.{' '}
          <br />
          En cas de désaccord sur le traitement ou l’issue de votre réclamation, nous vous informons
          que vous avez la possibilité de formuler un recours devant la juridiction ou l’autorité
          compétente. <br />
          Les réclamations clients sont conservées pendant un délai de 5 ans par Publiconsult.{' '}
          <br />
          CONDITION D’UTILISATION <br />
          L'utilisation du présent site implique l'acceptation pleine et entière des conditions
          générales d’utilisation. Ces conditions d'utilisation sont susceptibles d'être modifiées
          ou complétées à tout moment. <br />
          <br />
          <br />
          <br />
          INFORMATION <br />
          Les informations et documents du site sont présentés à titre indicatif, sans caractère
          exhaustif, et ne peuvent engager la responsabilité du propriétaire du site. <br />
          Le propriétaire du site ne peut être tenu responsable des dommages directs et indirects
          consécutifs à l’accès au site. <br />
          PROPRIÉTÉ INTELLECTUELLE <br />
          Sauf mention contraire, tous les éléments accessibles sur le site (textes, images,
          graphismes, logo, icônes, sons, logiciels, etc.) restent la propriété exclusive de leurs
          auteurs, en ce qui concerne les droits de propriété intellectuelle ou les droits d'usage.{' '}
          <br />
          Toute reproduction, représentation, modification, publication, adaptation de tout ou
          partie des éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite,
          sauf autorisation écrite préalable de l’auteur. <br />
          Toute exploitation non autorisée du site ou de l’un quelconque des éléments qu’il contient
          est considérée comme constitutive d'une contrefaçon et passible de poursuites. <br />
          Les marques et logos reproduits sur le site sont déposés par les sociétés qui en sont
          propriétaires. <br />
          CONFIDENTIALITÉ : <br />
          Tout utilisateur dispose d’un droit d'accès, de rectification et d’opposition aux données
          personnelles le concernant, en effectuant sa demande écrite et signée, accompagnée d'une
          preuve d'identité. Le site ne recueille pas d'informations personnelles, et n’est pas
          assujetti à déclaration à la CNIL. <br />
          LIENS HYPERTEXTES <br />
          Les liens hypertextes établis en direction d'autres sites ne sauraient engager la
          responsabilité de Publiconsult, notamment s'agissant du contenu de ces sites. <br />
          Publiconsult n'est pas responsable des liens hypertextes pointant vers le présent site et
          interdit à toute personne de mettre en place un tel lien sans son autorisation expresse et
          préalable. <br />
          TÉMOINS DE CONNEXION OU « COOKIES » <br />
          Pour votre sécurité, ce site utilise les "cookies". Il s'agit de petits fichiers texte
          stockés en mémoire par votre navigateur et qui servent à vous identifier à chaque
          changement de page sur le site.
        </p>
      </div>
    </>
  );
};
